// extracted by mini-css-extract-plugin
module.exports = {"productImages":"_3yQPH","productImageWrapper":"_3ThZY","productImage":"_1a7I2","productBadge":"_1K66t"};